import i18n from 'i18next';
import { z } from 'zod';

z.config({
  customError: (issue) => {
    switch (issue.code) {
      case 'too_big':
        if (issue.origin === 'number') {
          return i18n.t('common.errors.numberTooBig', {
            value: issue.maximum,
          });
        }
        return;

      case 'too_small':
        if (issue.origin === 'number') {
          return i18n.t('common.errors.numberTooSmall', {
            value: issue.minimum,
          });
        }
        return;

      case 'invalid_type':
        if (issue.input === undefined) {
          // This invariably means a required value has yet to be entered but it shows as an invalid type error.
          return i18n.t('common.formErrors.required');
        }
        break;

      default:
        return;
    }
  },
});
